import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/test-caller-ids/')({
  beforeLoad: () => {
    throw redirect({ to: '/test-caller-ids' })
  },
})
